import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import StotramsPage from "@/pages/StotramsPage";
import StotramDetailPage from "@/pages/StotramDetailPage";
import InsightsPage from "@/pages/InsightsPage";
import AuthenticityPage from "@/pages/AuthenticityPage";
import ContactPage from "@/pages/ContactPage";
import VerseJsonTool from "@/pages/VerseJsonTool";
import WatchListenPage from "@/pages/WatchListenPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

// Routes that must render WITHOUT the site's standard header / footer /
// navigation chrome (e.g. /watch-listen — a focused link-in-bio landing
// page). Kept as a set so future standalone routes can opt out cleanly.
const BARE_ROUTES = new Set(["/watch-listen"]);

const AppShell = () => {
  const { pathname } = useLocation();
  // Normalise trailing slash so /watch-listen and /watch-listen/ behave
  // identically (static hosts may serve either form).
  const normalized = pathname.replace(/\/+$/, "") || "/";
  const bare = BARE_ROUTES.has(normalized);
  return (
    <>
      <ScrollToTop />
      {!bare && <Navigation />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/stotrams" element={<StotramsPage />} />
        <Route path="/stotrams/:slug" element={<StotramDetailPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/authenticity" element={<AuthenticityPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/tools/verse-json" element={<VerseJsonTool />} />
        <Route path="/watch-listen" element={<WatchListenPage />} />
      </Routes>
      {!bare && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-ivory text-charcoal">
      <BrowserRouter>
        <AppShell />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#1C1B1A",
              color: "#F9F6F0",
              border: "1px solid rgba(169,146,96,0.3)",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
              letterSpacing: "0.05em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
